import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ICerere, IHistoryEntry, User } from '../../cereri.interface';
import { CereriService } from '../../cereri.service';
import { AppFilesService } from 'src/app/services/app-files.service';
import { helper } from 'src/environments/helper';
import { FormControl, FormGroup } from '@angular/forms';
import { finalize, map } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-istoric-cerere',
    templateUrl: './istoric-cerere.component.html',
    styleUrls: ['./istoric-cerere.component.scss']
})
export class IstoricCerereComponent {
    @Output() cerereChanged: EventEmitter<void> = new EventEmitter();
    @Input() istoric: IHistoryEntry[] = [];
    @Input() user!: User;
    @Input() notifyIds: any = [];
    @Output() isLoading = new EventEmitter<boolean>();

    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoadingOperator = false;
    isLoadingCitizen = false;
    isLoadingAll = false;
    isReportMessageLoading: { [key: number]: boolean } = {};
    filteredHistory!: IHistoryEntry[];

    searchParamsForm!: FormGroup;

    initialFormValue = {
        defaultValue: '-1',
    };
    messageTypes = [
        { key: '--Toate--', value: '-1' },
        { key: 'Către cetățean', value: ['0', '1'] },
        { key: 'Intern', value: ['2', '3'] },
    ];

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValue);
    }

    initFilterForm() {
        this.searchParamsForm = new FormGroup({
            messageType: new FormControl(this.initialFormValue.defaultValue),
        });
    }

    constructor(
        private cereriService: CereriService,
        private appFileService: AppFilesService,
        private notificationService: NotificationService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.filterHistoryByType();
    }

    ngOnInit(): void {
        this.initFilterForm();
    }

    filterHistoryByType() {
        const selectedType = this.searchParamsForm?.get('messageType')?.value || '-1';

        if (selectedType === '-1') {
            this.filteredHistory = (this.istoric || []);
        } else {
            this.filteredHistory = (this.istoric || []).filter(entry => selectedType.includes(entry.type.toString()));
        }
    }


    downloadDocument(file: any) {
        let fullPath = this.cereriService.downloadDocumentUrl + file.id;
        this.isLoading.emit(true);
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading.emit(false);
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading.emit(false);
            })
    }

    /*
     Pentru type-uri:
     1: Conv de operator + nota interna
     2: Conv de la cetatean
     3: Conv all
    */

    // exportConv(type: number) {
    //     // Set the appropriate loading flag to true based on the type
    //     if (type === 1) this.isLoadingOperator = true;
    //     if (type === 2) this.isLoadingCitizen = true;
    //     if (type === 3) this.isLoadingAll = true;

    //     this.cereriService.exportHistory(this.id_cerere, type).subscribe({
    //         next: (data: Blob) => {
    //             const blobUrl = URL.createObjectURL(data);
    //             window.open(blobUrl, '_blank');
    //             this.resetLoadingFlags();
    //         },
    //         error: (error) => {
    //             console.error('Error exporting PDF:', error);
    //             this.resetLoadingFlags();
    //         }
    //     });
    // }

    resetLoadingFlags() {
        this.isLoadingOperator = false;
        this.isLoadingCitizen = false;
        this.isLoadingAll = false;
    }

    resendMessage(cerereHistoryId: number) {
        this.isReportMessageLoading[cerereHistoryId] = true;
        this.cereriService.rePostMessage(cerereHistoryId)
            .pipe(finalize(() => { this.isReportMessageLoading[cerereHistoryId] = false }))
            .subscribe({
                next: () => {
                    // Refresh the cereri-detalii component
                    this.cerereChanged.emit();
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
